import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { EnvironmentConfig } from '../../../environments/environmentConfig';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

declare var $: any;
@Component({
    selector: 'address-validation-popup',
    templateUrl: './address-validation-popup.component.html',
    styleUrls: ['./address-validation-popup.component.less'],
    providers: [FrameworkUtilityComponent, EnvironmentConfig]
})
export class AddressValidationPopupComponent implements OnInit {
    @Input() ecifResponseData: any;
    @Input() sameAddressData: any;
    @Output() addressDataEmitter: EventEmitter<any> = new EventEmitter<any>();
    preQualObj: any;
    mobilenumber: string;
    responseData = [];
    operationMetaData: any;
    apiCertificate: any;
    cleansData: any;
    suggestedAddress: any;
    prequalUser: any;
    displayValidation: boolean;
    originalAddress: any;
    borderColorY: boolean[] = [];
    borderColorN: boolean;
    suggestedAddressSeparatedData: any;
    originalAddressSeparatedData: any;
    suggestedAddressArray: any[];
    originalAddressArray: any[];
    borderColor: boolean[] = [];
    borderColorR: boolean[] = [];
    selectedAddress: any;
    ind: any;
    addressSuggestionResponse: any;
    outputArray: any[] = [];
    addressAPICertificate: string;
    addressForm: FormGroup;
    addressData = [];
    applicantTitle = ['Applicant', 'Co-applicant'];
    formattedOriginalAddress: any = [];
    formattedSuggestedAddress: any = [];
    coApplicantSuggesting: boolean = false;
    originalAddressIndex: number;


    constructor(private util: UtilService, private utilService: UtilService, private fb: FormBuilder) {
        this.preQualObj = this.util.getSessionStorage();
    }

    ngOnInit(): void {
        this.preQualObj = this.util.getSessionStorage();
        const applicants = [];
        if ('applicant' in this.ecifResponseData && 'coapplicant' in this.ecifResponseData) {
            applicants[0] = this.ecifResponseData.applicant;
            applicants[1] = this.ecifResponseData.coapplicant;
        }
        else if ('applicant' in this.ecifResponseData) {
            applicants[0] = this.ecifResponseData.applicant;
        }
        else {
            applicants[0] = this.ecifResponseData.coapplicant;
            this.coApplicantSuggesting = true;
        }

        if (this.ecifResponseData)
            this.responseData[0] = applicants[0];
        this.responseData[1] = applicants[1];
        this.addressData = applicants.map((user, index) => {
            const mainApp = user.main_application;
            const matchedSuggested = this.responseData[index];
            let suggestedAddress = '';
            if (matchedSuggested?.cleansedAddrss) {
                const f = matchedSuggested.cleansedAddrss;
                suggestedAddress = `${f.street}, ${f.city}, ${f.provinceState}, ${f.postalCode} `;
                this.formattedSuggestedAddress[index] = `${f.street}<br>${f.city}, ${f.provinceState}, ${f.postalCode}<br>Canada`
            }
            let addressCertificate = '';
            if (matchedSuggested?.addressAPICertificate) {
                addressCertificate = matchedSuggested.addressAPICertificate;
            }
            this.originalAddressIndex = index;
            if (this.coApplicantSuggesting) {
                this.originalAddressIndex = 1;
            }
            const matchedOriginal = this.preQualObj.users[this.originalAddressIndex];
            const line1 = matchedOriginal.addressline1 || '';
            const line2 = matchedOriginal.addressline2 ? ` ${matchedOriginal.addressline2}` : '';
            const city = matchedOriginal.city || '';
            const province = matchedOriginal.province || '';
            const postal = matchedOriginal.postal_code || '';
            const originalAddress = `${line1}${line2}, ${city}, ${province}, ${postal}`;
            this.formattedOriginalAddress[index] = `${line1}${line2}<br>${city}, ${province}, ${postal}<br>Canada`

            return {
                main_application: mainApp,
                original_address: originalAddress,
                suggested_address: suggestedAddress,
                address_certificate: addressCertificate,
                status: status
            };
        });
        this.addressForm = this.fb.group({
            addresses: this.fb.array(this.addressData.map((item) =>
                this.fb.group({
                    main_application: item?.main_application,
                    selectedAddress: ['', Validators.required],
                    addressCertificate: item?.address_certificate
                })
            ))
        });


    }

    get addressesArray(): FormArray {
        return this.addressForm.get('addresses') as FormArray;
    }
    checkObject(obj) {
        if (Object.keys(obj).length != 0) {
            return true;
        }
    }

    onSubmit() {
        const selectedAddressArray = this.addressForm.value.addresses;

        selectedAddressArray.forEach(item => {
            if (item.selectedAddress) {
                item.selectedAddress = item.selectedAddress.trim();
            }
        });
        this.addressDataEmitter.emit(selectedAddressArray);
    }

}


